import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITAFBookS1 } from './taf-book-s1-list';


import { HttpHelper } from '../../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TAFBookS1Service {

    //need to have this somewhere besides hardcoded in here
    
    //private _tafBookS1Url = ` http://localhost:55706/api/systemmanagement/TAFBookS1`;
    private _tafBookS1Url = `api/systemmanagement/TAFBookS1`;

    constructor(private httpHelper: HttpHelper) { }

    getTAFBookS1(): Observable<ITAFBookS1> {
         return this.httpHelper.get(`${this._tafBookS1Url}`);
             //.map((response: Response) => <ITAFBookS1> response.json())
             //.do(data => console.log('ITafBookS1: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-s1/taf-book-s1.service.ts
 **/